// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HEADER_BREAKPOINT } from "@eisinc/Overrides/Pages/Header";
import { logoLinksSearchStyles } from "@eisinc/Overrides/Widgets/Header/LogoLinksSearch";
import { DivWrapper } from "@eisinc/XDL/constants";
import { color, layoutContainer, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

logoLinksSearchStyles.container = {
    css: css`
        background: ${color("common.white")};
    `,
};

logoLinksSearchStyles.innerContainer = {
    css: css`
        display: grid;
        grid-template-columns: 164px 1fr auto;
        justify-content: space-between;
        align-items: center;
        gap: 12px 36px;
        padding-block: 12px;

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            box-shadow: 0 1px 0 0 ${color("common.ui3")};
            grid-template-columns: minmax(100px, auto) auto;
            gap: 12px 12px;
        }
        ${layoutContainer}
    `,
};

logoLinksSearchStyles.logoWrapper = {
    css: css`
        width: 164px;
        height: 79px;
        max-height: 79px;
        aspect-ratio: 164 / 79;
        ${xScreen("lte", HEADER_BREAKPOINT)} {
            width: auto;
            height: auto;
            aspect-ratio: auto;
        }
        img {
            max-height: 100%;
            max-width: 100%;
            width: auto;
            height: auto;
        }
    `,
};

logoLinksSearchStyles.searchMenuWrapper = {
    css: css`
        ${xScreen("lte", HEADER_BREAKPOINT)} {
            grid-area: 2/1/3/3;
        }
    `,
};

logoLinksSearchStyles.linksWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 28px;
        justify-content: flex-end;

        & > ${DivWrapper}:empty {
            display: none;
        }

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            gap: 20px;
            max-height: 30px;
            padding-top: 4px;
            align-items: flex-start;
            grid-area: 1/2/2/3;
        }
    `,
};
